import * as Immutable from 'immutable';
import * as React from 'react';

import { localeData } from '../../../locales/data';
import { addModifiers } from '../../../shared/helpers';

import './Filters.scss';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

interface FiltersProps {
  handleFilters: (filter: string) => void;
  queryFilters: Immutable.List<string>;
  handlerToogleFilter: (action: boolean) => void;
  filterOpen: boolean;
}

interface SearchFiltersProps {
  handlerToogleFilter: (action: boolean) => void;
  filterOpen: boolean;
}

const SearchFilters = ({ handlerToogleFilter, filterOpen }: SearchFiltersProps) => {
  const toogleFilter = () => handlerToogleFilter(!filterOpen);

  return (
    <div className="learn-filters__dropdown">
      <button className={addModifiers('learn-filters__filter-button', filterOpen ? ['active'] : [])} onClick={toogleFilter}>
        <FormattedMessageHelper
          tagName="span"
          id="learn.search.filter.dropdown"
          defaultMessage={localeData.en['learn.search.filter.dropdown']}
        />
      </button>
    </div>
  );
};

export const Filters = ({ handleFilters, handlerToogleFilter, queryFilters, filterOpen }: FiltersProps) => {
  const filters: any = {
    video: 'learn.search.filters.courses',
    tutorialPage: 'learn.search.filters.tutorials',
    reference: 'learn.search.filters.references',
  };

  return (
    <React.Fragment>
      <div className="learn-filters">
        <div className="learn-filters__text">
          <FormattedMessageHelper tagName="span" id="learn.search.filter.by" defaultMessage={localeData.en['learn.search.filter.by']} />
        </div>

        <div className="learn-filters--mobile">
          <SearchFilters handlerToogleFilter={handlerToogleFilter} filterOpen={filterOpen} />
        </div>
        <ul className="learn-filters__list">
          {Object.keys(filters).map((key: string, index: number) => {
            const handle = () => {
              handleFilters(key);
            };

            const modifiers = queryFilters.includes(key) ? ['active'] : [];

            return (
              <li className="learn-filters__item" key={`learn-filters-${index}-${filters[key]}`}>
                <button className={addModifiers('learn-filters__btn', modifiers)} onClick={handle}>
                  <FormattedMessageHelper tagName="span" id={filters[key]} defaultMessage={localeData.en[filters[key]]} />
                </button>
              </li>
            );
          })}
        </ul>
      </div>
      <div className={addModifiers('events__menu-filters-content', filterOpen ? ['active'] : [])}>
        <ul className="learn-filters__list--mobile">
          {Object.keys(filters).map((key: string, index: number) => {
            const handle = () => {
              handleFilters(key);
            };

            const modifiers = queryFilters.includes(key) ? ['active'] : [];

            return (
              <li className="learn-filters__item" key={`learn-filters-${index}-${filters[key]}`}>
                <button className={addModifiers('learn-filters__btn', modifiers)} onClick={handle}>
                  <FormattedMessageHelper tagName="span" id={filters[key]} defaultMessage={localeData.en[filters[key]]} />
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </React.Fragment>
  );
};
